// VUE
import Vue from 'vue'
import Router from 'vue-router'
// Component Pages
import Homepage from '@/components/Homepage'
import Apply from '@/components/apply/Apply'
import Design from '@/components/design/Design'
import Gallery from '@/components/gallery/Gallery'
import Login from '@/components/account/Login'
import Register from '@/components/account/Register'
import Help from '@/components/Help'
// Plugins I have to call from global scope (for some reason)
import VueCircleSlider from 'vue-circle-slider'
import ToggleButton from 'vue-js-toggle-button'

// Load 
Vue.use(VueCircleSlider)
Vue.use(Router)
Vue.use(ToggleButton)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      // name: 'homepage',
      // component: Homepage
      redirect: { name: 'Apply' }
    },
    {
      path: '/apply',
      name: 'Apply',
      component: Apply
    },
    {
      path: '/design',
      name: 'Design',
      component: Design
    },
    {
      path: '/gallery',
      name: 'Gallery',
      component: Gallery
    },    
    {
      path: '/login',
      name: 'Login',
      component: Login
    },    
    {
      path: '/register',
      name: 'Register',
      component: Register
    },        
    {
      path: '/help',
      name: 'Help',
      component: Help
    }
  ]
})
export default router

